import whenDomReady from 'when-dom-ready';
function initialise() {
    const successStoryVideos = Array.from(document.querySelectorAll('.js-video-play'));
    if (!successStoryVideos) {
        return;
    }
    successStoryVideos.forEach(initialiseModalVideo);
}
export function initialiseModalVideo(video) {
    const modal = document.querySelector('.js-modal');
    const modalClose = document.querySelector('.js-modal-close');
    const iframePlayer = document.querySelector('.js-player-iframe');
    if (!modal || !modalClose || !iframePlayer) {
        return;
    }
    video.addEventListener('click', () => {
        modal.classList.add('active');
        const videoID = video.getAttribute('data-video-id');
        if (!videoID) {
            return;
        }
        iframePlayer.src = `https://www.youtube.com/embed/${videoID}?origin=https://plyr.io&amp;iv_load_policy=3&amp;modestbranding=1&amp;playsinline=1&amp;showinfo=0&amp;rel=0&amp;enablejsapi=1"`;
    });
    modalClose.addEventListener('click', () => {
        modal.classList.remove('active');
        iframePlayer.src = '';
    });
}
whenDomReady().then(initialise);
